import { useEffect, useRef, useState } from 'react';
import { Col, Row } from '../../../lib/utils';
import { useQuery } from '@tanstack/react-query';
import dayjs from 'dayjs';
import { getDailyScheduleAPI } from '../../../api/schedule';
import { dailySchedulesCountDummyData, dailySchedulesDummyData } from '../../DailySchedule/DummyData';
import CoachList from './CoachList';
import ScheduleTableLayout from './ScheduleTableLayout';
import ScheduleTableInnerBox from './ScheduleTableInnerBox';
import ModalRegisterSchedule from '../../DailySchedule/ModalRegisterSchedule/ModalRegisterSchedule';
import { I_FLOATING } from '../../../types/images';
import GridShadow from '../GridShadow';
import { LEGACY_DAILY_CELL_HEIGHT_DEFAULT } from '../legacyCalendarLayout';

const DailySchedule = ({
    setIsLoading,
    grid,
    currentDate,
    authorization,
    authObject,
    createAlert,
    createTwoButtonAlert,
    selectedDay,
    setSelectedDay,
    selectedSchedule,
    setSelectedSchedule,
    onClickFloatingButton,
    onClickSchedule,
    onClickRequest,
    onClickEtcOffSchedule,
    onClickNewOpportunity,
    onClickApproveScheduleRequest,
    onClickRejectScheduleRequest,
    scrollY,
    dailyCurrentData,
    scheduleCountByCoach,
    gridData,
    onClickHover,
    currentPage,
    endPage,
    handleNextPage,
    handlePrevPage,
    handleOrderChange,
    cellHeight = LEGACY_DAILY_CELL_HEIGHT_DEFAULT,
}: any) => {
    return (
        <Col style={{ marginTop: 88 }}>
            <CoachList
                dailyCurrentData={dailyCurrentData}
                scheduleCountByCoach={scheduleCountByCoach}
                scrollY={scrollY}
                currentPage={currentPage}
                endPage={endPage}
                handleNextPage={handleNextPage}
                handlePrevPage={handlePrevPage}
                handleOrderChange={handleOrderChange}
            />
            <ScheduleTableLayout
                dailyCurrentData={dailyCurrentData}
                gridData={gridData}
                scrollY={scrollY}
                onClickHover={onClickHover}
                selectedDay={selectedDay}
                cellHeight={cellHeight}
            />
            <ScheduleTableInnerBox
                onClickSchedule={onClickSchedule}
                onClickRequest={onClickRequest}
                onClickEtcOffSchedule={onClickEtcOffSchedule}
                onClickNewOpportunity={onClickNewOpportunity}
                onClickRejectScheduleRequest={onClickRejectScheduleRequest}
                onClickApproveScheduleRequest={onClickApproveScheduleRequest}
                dailyCurrentData={dailyCurrentData}
                scrollY={scrollY}
                cellHeight={cellHeight}
            />
            {/* 음영처리 */}
            <GridShadow currentDate={currentDate} selectedDay={selectedDay} cellHeight={cellHeight} />
        </Col>
    );
};

export default DailySchedule;
